import { makeStyles, Toolbar, Typography, Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	buttonChange: {
		position: 'relative',
		overflow: 'visible',
		paddingBottom: '5px',
		paddingTop: '5px',
		background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
		'&::before': {
			content: '""',
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
			width: 360,
			background: 'linear-gradient(90deg, rgba(4, 58, 92, 0.4) 0%, rgba(7, 76, 118, 0.24) 62%, rgba(7, 76, 118, 0) 100%)',
			pointerEvents: 'none'
		},
		'& > *': {
			position: 'relative',
			zIndex: 1
		},
		//estilo agregado para q en la funcion windows.print() este componente nunca este en la imagen de el pdf.
		"@media print": {
			display: 'none'
		},
		"@media (max-width: 920px)": {
			display: 'flex',
			flexDirection: 'column'
		}
	},
	toolbar: {
		position: 'relative',
		overflow: 'visible',
		paddingBottom: '5px',
		paddingTop: '5px',
		background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
		'&::before': {
			content: '""',
			position: 'absolute',
			left: 0,
			top: 0,
			bottom: 0,
			width: 360,
			background: 'linear-gradient(90deg, rgba(4, 58, 92, 0.4) 0%, rgba(7, 76, 118, 0.24) 62%, rgba(7, 76, 118, 0) 100%)',
			pointerEvents: 'none'
		},
		'& > *': {
			position: 'relative',
			zIndex: 1
		},
		"@media (max-width: 920px)": {
			display: "flex",
			flexWrap: "wrap"
		},
		//estilo agregado para q en la funcion windows.print() este componente nunca este en la imagen de el pdf.
		"@media print": {
			display: 'none'
		},
	},
	titulo: {
		marginLeft: 64,
		color: theme.palette.common.white,
		cursor: "default",
		"@media (max-width: 920px)": {
			marginLeft: 5,
			marginTop: 10
		}
	},
	titleGroup: {
		display: 'flex',
		alignItems: 'center',
		minWidth: 0,
		"@media (max-width: 920px)": {
			width: '100%',
			flexWrap: 'wrap',
			rowGap: theme.spacing(1),
		}
	},
	titleActions: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: theme.spacing(2),
		"@media (max-width: 920px)": {
			marginLeft: 0,
			marginTop: 0,
			marginRight: 0,
			flex: '1 1 220px',
			justifyContent: 'flex-end',
		}
	},
	containerChildren: {
		position: 'relative',
		display: 'flex',
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		minWidth: 0,
		"@media (max-width: 920px)": {
			flex: '1 1 100%',
			width: '100%',
			justifyContent: 'flex-start',
			marginTop: theme.spacing(1),
		}
	}
}));

export default function TopNav(props) {
	const classes = useStyles();
	const marginTop = () => {
		if (props.marginTop === true) {
			return 0
		} else {
			return 48
		}
	}

	const marginLeft = () => {
		if (props.marginLeft === true) {
			return 0
		}
	}
	return (
		<Toolbar className={props?.changeTitleStyleFlex ? classes.buttonChange : classes.toolbar} style={{ marginTop: marginTop() }}>

			{props.iconButton}
			<Box className={classes.titleGroup}>
				<Typography variant='subtitle1' className={classes.titulo} style={{ marginLeft: marginLeft() }}>
					{props.titulo} <span style={{ fontWeight: '300' }}>{props.subtitulo}</span>
				</Typography>
				{props.titleActions && (
					<Box className={classes.titleActions}>
						{props.titleActions}
					</Box>
				)}
			</Box>

			<Box className={classes.containerChildren}>
				{props.children}
			</Box>

		</Toolbar>
	);
}
